import Vue from 'vue';

Vue.component('logo-index', () =>
    import(/* webpackChunkName: 'logo-index' */ './logo-index.vue'),
);
